<template>
    <v-dialog v-if="isView" v-model="isView" persistent width="800">
        <v-card class="mt-3">
            <v-card-title class="pa-0">
                <v-app-bar dense color="primary" dark elevation="0">
                    <v-list-item-title>
                        <span>表示条件</span>
                    </v-list-item-title>
                    <TitleButton
                        color="primary"
                        icon="mdi-floppy"
                        name="表示"
                        @click="onClickView()" />
                    <TitleButton
                        color="primary"
                        icon="mdi-close-circle"
                        name="閉じる"
                        @click="isView = false" />
                </v-app-bar>
            </v-card-title>
            <v-card-text class="pa-0">
                <v-container>
                    <v-row dense align="baseline">
                        <v-col>
                            <v-select 
                                dense 
                                v-model="viewCondition.condition.targetDate.value.year" 
                                label="追加・採苗年"
                                hint="この年に追加された苗を表示します。(必須指定)" 
                                persistent-hint
                                outlined 
                                :items="years" 
                                return-object/>
                        </v-col>
                        <v-col v-if="viewCondition.condition.targetDate.value.year != null">
                            <v-select 
                                dense 
                                v-model="viewCondition.condition.targetDate.value.month"
                                clearable 
                                label="追加・採苗月" 
                                hint="この月に追加された苗を表示します。" 
                                persistent-hint
                                outlined 
                                :items="months" 
                                return-object 
                                @change="onChangedTargetMonth" />
                        </v-col>
                        <v-col v-if="viewCondition.condition.targetDate.value.month != null">
                            <v-select 
                                dense 
                                v-model="viewCondition.condition.targetDate.value.day" 
                                clearable 
                                label="追加・採苗日" 
                                hint="この日に追加された苗を表示します。" 
                                persistent-hint
                                outlined 
                                :items="days" 
                                return-object />
                        </v-col>
                    </v-row>
                    <v-row dense align="baseline">
                        <v-checkbox dense v-model="viewCondition.condition.name.enabled" />
                        <v-col>
                            <v-text-field 
                                dense 
                                v-model="viewCondition.condition.name.value" 
                                clearable 
                                label="名前" 
                                hint="この名前の苗を表示します。" 
                                persistent-hint
                                outlined 
                                type="text" 
                                :disabled="!viewCondition.condition.name.enabled"/>
                        </v-col>
                    </v-row>                
                    <v-row dense align="baseline">
                        <v-checkbox dense v-model="viewCondition.condition.place.enabled" />
                        <v-col>
                            <v-select 
                                dense 
                                v-model="viewCondition.condition.place.value" 
                                clearable 
                                label="場所" 
                                hint="この場所にある苗を表示します。" 
                                persistent-hint
                                outlined 
                                :items="places" 
                                item-text="name" 
                                item-value="placeID" 
                                :disabled="!viewCondition.condition.place.enabled"/>
                        </v-col>
                    </v-row>
                    <v-row dense align="baseline">
                        <v-checkbox dense v-model="viewCondition.condition.variety.enabled" />
                        <v-col>
                            <v-select 
                                dense 
                                v-model="viewCondition.condition.variety.value.cropID" 
                                label="作物" 
                                hint="この作物の苗を表示します。" 
                                persistent-hint
                                outlined 
                                :items="crops" 
                                item-text="body.name" 
                                item-value="body.cropID" 
                                :disabled="!viewCondition.condition.variety.enabled" 
                                @change="onChangedCrop"/>
                        </v-col>
                        <v-col v-if="viewCondition.condition.variety.enabled && viewCondition.condition.variety.value.cropID != null">
                            <v-select 
                                dense 
                                v-model="viewCondition.condition.variety.value.varietyID" 
                                label="品種" 
                                hint="この品種の苗を表示します。" 
                                persistent-hint
                                outlined 
                                :items="varieties" 
                                item-text="name" 
                                item-value="varietyID"/>
                        </v-col>
                    </v-row>
                    <v-row dense align="baseline">
                        <v-checkbox dense v-model="viewCondition.condition.state.enabled" />
                        <v-col>
                            <v-select 
                                dense 
                                v-model="viewCondition.condition.state.value" 
                                clearable 
                                label="状態" 
                                hint="この状態の苗を表示します。" 
                                persistent-hint
                                outlined 
                                :items="states" 
                                item-text="text" 
                                item-value="value" 
                                :disabled="!viewCondition.condition.state.enabled" 
                                @change="onChangedState"/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-switch 
                                dense 
                                v-model="viewCondition.condition.isDiscardedNotView" 
                                hint="ONの時は、廃棄された苗が表示されません。" 
                                persistent-hint
                                label="廃棄は表示しない"/>
                        </v-col>
                        <v-col>
                            <v-switch 
                                dense 
                                v-model="viewCondition.condition.isOrderOfGeneration" 
                                hint="ONの時は、親の直下にその苗から採苗された子苗が表示されます。(但し、条件に該当している時)" 
                                persistent-hint
                                label="親子を纏める" />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    import TitleButton from '@/components/tools/TitleBarButton';
    export default {
        components: {
            TitleButton
        },
        props: {
            viewCondition: Object,
            places: Array,
            crops: Array
        },
        data: function () {
            return {
                isView: false,
                // // ====================================
                // // 表示条件
                // // 初期値は、showメソッドにおいて設定
                // viewCondition: {
                //     condition: {
                //         targetDate: {
                //             value: {
                //                 year: null,
                //                 month: null,
                //                 day: null
                //             }
                //         },
                //         name: {enabled: false, value:null},
                //         place: {enabled: false, value:null},
                //         variety: {
                //             enabled: false,
                //             value: {
                //                 cropID: null,
                //                 varietyID: null,
                //             }
                //         },
                //         state: {enabled: false, value:null},
                //         isDiscardedNotView: false,
                //         isOrderOfGeneration: false,
                //     },
                //     orders: [],
                // },
                // ====================================
                // 並び順項目
                orderItems: [
                    {
                        id: 1,
                        name: "状態",
                        items: [
                            {value:1, text:"育苗→栽植"},
                            {value:2, text:"栽植→育苗"},
                        ]
                    },
                    {
                        id: 2,
                        name: "品種",
                        items: [
                            {value:1, text:"昇順"},
                            {value:2, text:"降順"},
                        ]
                    },
                    {
                        id: 3,
                        name: "場所",
                        items: [
                            {value:1, text:"昇順"},
                            {value:2, text:"降順"},
                        ]
                    },
                    {
                        id: 4,
                        name: "開始日",
                        items: [
                            {value:1, text:"昇順"},
                            {value:2, text:"降順"},
                        ]
                    },
                ],
                states: [
                    {value: 1, text:"育苗中"},
                    {value: 2, text:"栽植中"},
                    {value: 99, text:"廃棄"},
                ],
                years: [],
                months: [1,2,3,4,5,6,7,8,9,10,11,12],
                days: [],
                varieties: []
            }
        },
        created: function () {
            this.years = []
            for (var year=2020; year<=2030; year++){
                this.years.push(year)
            }
        },
        methods: {
            onClickView: function () {
                this.$emit("onChangedViewCondition", this.viewCondition)
                this.isView = false
            },
            onChangedTargetMonth: function () {
                this.days = []
                if (this.viewCondition.condition.targetDate.value.month == null) {
                    this.viewCondition.condition.targetDate.value.month = null
                    return
                }
                const lastDay = (new Date(this.viewCondition.condition.targetDate.value.year, this.viewCondition.condition.targetDate.value.month, 0)).getDate()
                for (var day=1; day<=lastDay; day++) {
                    this.days.push(day)
                }
            },
            onChangedCrop: function () {
                const index = this.crops.findIndex((v)=>v.body.cropID === this.viewCondition.condition.variety.value.cropID)
                this.varieties = this.crops[index].varieties
                this.viewCondition.condition.variety.value.varietyID = null
            },
            onChangedState: function () {
                if (this.viewCondition.condition.state.value == 99) {
                    this.viewCondition.condition.isDiscardedNotView = false
                }
            },
            show: function () {                
                this.isView = true
            }
        }
    }
</script>

<style>
    v-row {
        margin-top: -30px
    }
</style>